// @flow
import type { CurrentDeviceState } from '../reducers'

export const SET_DEVICE_INFO_TYPE = 'device_info/SET_DEVICE_INFO'

export const setDeviceInfo: any = (deviceInfo: CurrentDeviceState) => ({
  type: SET_DEVICE_INFO_TYPE,
  payload: deviceInfo,
})
